import React, { Fragment, useRef, useState } from "react";
import Table from "../table/Table";
import CustomPagination from "../table/CustomPagination";
import { Button as ColumnButton, Column } from "devextreme-react/data-grid";
import AdminDialog from "./AdminDialog";
import { CheckBox, NumberBox, TextArea} from "devextreme-react";
import SelectBox from "../common/CustomSelectBox";
import TagBox from "../common/CustomTagBox"
import { TextBox } from 'devextreme-react/text-box';
import { Button, Menu, MenuItem, Typography } from "@material-ui/core";
import { PasswordInput } from "./PasswordInput";
import { TaxonomySelector } from "./campaigns/TaxonomySelector";
import genericAddIcon from "../../images/add-icon-white.svg"
import searchIcon from "../../images/ui-ic-search.svg"
import {Button as TextBoxButton } from 'devextreme-react/text-box';
import editIcon from "../../images/edit.svg"
import deleteIcon from "../../images/delete.svg"
import { useTranslation } from "react-i18next";

const AdminTable = ({sortField, setsortField, sectionTitle, dataSource, columnasTabla, getData, loading, numElements, onCustomEditingStart = null, onCustomDeletingStart = null, onSaving, onCreate, onEdit, onDelete, masterTitle, customCreation= false, itemIdField, itemDescriptionField, allowCreate = true, allowDelete = ()=>true, customSearchFields, customAddIcon, dialogSize, master = false, masterDetail = null}) => {
    const { t } = useTranslation();
    const {pageIndex, pageSize} = dataSource;
    const [searchField, setSearchField] = useState("");
    const [editValues, setEditValues] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [operation, setOperation] = useState(null)
    const [dialogTitle, setDialogTitle] = useState("")
    const openDialog = editValues !== null || selectedItem !== null;
    const tableRef = useRef(null);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl ]= useState(null)

    function handlePageSizeChange(value){
        getData({pageIndex: 0, pageSize: value, searchString: searchField.trim(), orderByField: sortField.columna, orderByAscending: sortField.sortOrderAsc})
    }

    const handlePageIndexChange = (event, value) => {
        getData({pageIndex: value -1, pageSize: pageSize, searchString: searchField.trim(), orderByField: sortField.columna, orderByAscending: sortField.sortOrderAsc})
    };

    function handleSearch(){
        getData({pageSize: pageSize, pageIndex: 0, searchString: searchField.trim(), orderByField: sortField.columna, orderByAscending: sortField.sortOrderAsc})
    }

    function handleRefresh(){
        getData({pageIndex: pageIndex, pageSize: pageSize, searchString: searchField.trim(), orderByField: sortField.columna, orderByAscending: sortField.sortOrderAsc})
    }

    function handleStartEditing({row}){
        const entityValues = row.cells.map(cell=>
        {
         if(cell.column.type !== "buttons" && cell.column.allowEditing){
                const dataType = cell.column.lookup ? "lookup" : (cell.column.dataType || "string");
                const editData = {
                                key: cell.column.dataField,
                                value: cell.column.lookup? Array.isArray(cell.value) ? cell.value.map(v=> v[cell.column.lookup.valueExpr] || v) : cell.value : dataType === "string" && !cell.value ? "" : cell.value,
                                dataType: dataType,
                                label: cell.column.caption,
                                options: cell.column.lookup
                            }
                return editData
         }
        }
        ).filter(row=> row !== undefined);

        const entityId = {
            [itemIdField]: row.key[itemIdField],
            [itemDescriptionField]: row.key[itemDescriptionField]
        }
    
        setSelectedItem(entityId)
        setEditValues(entityValues)
        setOperation("edit")
        setDialogTitle(`${t("Edit")} ${masterTitle}`)
        setSelectedRowData(null)
        setMenuAnchorEl(null)
    }

    function handleStartEditingCustom(data){
        onCustomEditingStart(data)
        setMenuAnchorEl(null)
        setSelectedRowData(null)
    }

    function handleEditField(field, newValue){
        const updatedValues = editValues.map((originalValue)=> originalValue.key === field? {...originalValue, value: newValue.value} : originalValue )
        setEditValues(updatedValues)

    }


    function handleEditMultipleChoiceField(field, newValue){
            const updatedValues = editValues.map((originalValue)=> originalValue.key === field? {...originalValue, value: (newValue.length > 0 ? newValue : [])} : originalValue )
            setEditValues(updatedValues)
    }


    function handleTaxonomyChange(field, newTaxonomyValue) {
        const newValue = {
            level_1: newTaxonomyValue.taxonomyLevel_1,
            level_2: newTaxonomyValue.taxonomyLevel_2,
            level_3: newTaxonomyValue.taxonomyLevel_3,
            level_4: newTaxonomyValue.taxonomyLevel_4}

        const updatedValues = editValues.map((originalValue)=> originalValue.key === field? {...originalValue, value: newValue} : originalValue )
        setEditValues(updatedValues)
    }


    function handleOnSubmit(){
        if(operation === "create"){
            const createObject = editValues.reduce((object, editValue) => {   object[editValue.key] = editValue.value;  return object; }, {})
            onCreate(createObject, closeModal)
        }
        if(operation === "edit"){
            const editObject = editValues.reduce((object, editValue) => {   object[editValue.key] = editValue.value;  return object; }, {})
            onEdit({...editObject, [itemIdField] : selectedItem[itemIdField] }, closeModal)
        }
        if(operation === "delete"){
            const {[itemIdField] : deleteId} = selectedItem
            onDelete(deleteId, closeModal)
        }
    }

    function handleStartDeleting({row}){
        setOperation("delete")
        const entityValues = {
            [itemIdField]: row.key[itemIdField],
            [itemDescriptionField]: row.key[itemDescriptionField]
        }
    
        setSelectedItem(entityValues)
        setDialogTitle(`${t("Delete")} ${masterTitle}`)
        setSelectedRowData(null)
        setMenuAnchorEl(null)
    }

    function handleStartDeletingCustom(data){
        onCustomDeletingStart(data)
        setMenuAnchorEl(null)
        setSelectedRowData(null)
    }

    const columnsEdition = [
    <Column key={"Ações"} width={100} type={"buttons"} caption={t("Actions")}>
                <ColumnButton hint={t("Actions")} icon="more" onClick={(e)=>{setMenuAnchorEl(e.event.currentTarget); setSelectedRowData(e)}}/>
    </Column>
    ]

    function renderEditValues(){
        if(editValues !== null){
            return(
                editValues.map(editValue=>
                    <Fragment key={editValue.label}>
                        {
                            (editValue.dataType === "string" || !editValue.dataType) && 
                                <TextBox label={editValue.label} labelMode="floating" style={{height: "3rem"}} value={editValue.value} onValueChanged={(e)=>{handleEditField(editValue.key, e)}}/>
                        }
                        {
                            editValue.dataType === "textarea" && 
                                <TextArea label={editValue.label} labelMode="floating" height={120} value={editValue.value} onValueChanged={(e)=>{handleEditField(editValue.key, e)}}/>
                        }
                        {
                            editValue.dataType === "password" && 
                            <PasswordInput label={editValue.label}  value={editValue.value} setValue={(value)=>{handleEditField(editValue.key, value)}}/>

                        }
                        {
                            editValue.dataType === "number" && 
                                <NumberBox label={editValue.label}  labelMode="floating"  style={{height: "3rem"}} value={editValue.value} onValueChanged={(e)=>{handleEditField(editValue.key, e)}}/>
                        }
                        {
                            editValue.dataType === "boolean" &&
                                <span className="checkbox-label-wrapper">
                                    <CheckBox id={editValue.label} label={editValue.label}  labelMode="floating" value={editValue.value} onValueChanged={(e)=>{handleEditField(editValue.key, e)}}/>
                                    <label htmlFor={editValue.label}>{editValue.label}</label>
                                </span>
                        }
                        {
                            editValue.dataType === "lookup" && !editValue.options.multiple &&
                            <SelectBox
                            label={editValue.label}  
                            labelMode="floating" 
                            dataSource = { editValue.options.dataSource }
                            showClearButton = { false }
                            value = {editValue.value}
                            displayExpr = { editValue.options.displayExpr }
                            valueExpr = { editValue.options.valueExpr }
                            onValueChanged = {(e)=>{handleEditField(editValue.key, e)}}
                            searchEnabled = { true }
                            >
                            </SelectBox>
                        }
                        {
                            editValue.dataType === "lookup" && editValue.options.multiple &&
                            <TagBox
                            label={editValue.label} 
                            labelMode="floating" 
                            dataSource = { editValue.options.dataSource }
                            showClearButton = { false}
                            defaultValue = {editValue.value || null}
                            displayExpr = { editValue.options.displayExpr }
                            valueExpr = { editValue.options.valueExpr }
                            onValueChanged =  {(e)=>{handleEditMultipleChoiceField(editValue.key, e.value,)}}
                            searchEnabled = { true }
                            hideSelectedItems
                            >
                            </TagBox>
                        }
                        {
                            editValue.dataType === "taxonomy" &&
                            <TaxonomySelector selectedTaxonomy={editValue.value} index={0} handleTaxonomiesChange={(newValue)=>handleTaxonomyChange(editValue.key, newValue)}/>         
                             }
                    </Fragment>
                )
            )
        }
            
    } 

    function handleCreateNew(){
        setOperation("create")
        const visibleColumns = tableRef.current.instance.getVisibleColumns();
        const createFields = visibleColumns.map(column=>
        {
            if(column.type !== "buttons" && (column.allowEditing || column.allowCreating)){
                   const dataType = column.lookup ? "lookup" : (column.dataType || "string");
                   const editData = {
                        key: column.dataField,
                        dataType: dataType,
                        label: column.caption,
                        options: column.lookup,
                        value: dataType === "string" ? "" : dataType === "boolean" ? false : undefined
                    }
                   return editData
            }
        }
        ).filter(field=> field !== undefined)
        setEditValues(createFields)
        setDialogTitle(`Adicionar ${masterTitle}`)
    }

    function renderDeleteMessage(){
        if(selectedItem){
            return(
            <Typography>
            {`Se va a eliminar el ${masterTitle} "${selectedItem[itemDescriptionField]}".`}
            </Typography>
            )
        }
    }

    function closeModal(){
        setEditValues(null);
        setSelectedItem(null);
    }

    function handleCellClick (e) {
        if (e.rowType == "header" && (e.column.type !== "selection" && e.column.type !== "buttons" && e.column.allowSorting)) {
            let columna = e.column.dataField;
            let sortOrder = e.column.sortOrder;
            if (sortOrder == undefined || sortOrder == "undefined") {
                e.column.sortOrder = 'asc';
            }
            else if (sortOrder == 'desc') {
                e.column.sortOrder = 'asc';
            }
    
            else if (sortOrder == 'asc') {
                e.column.sortOrder = 'desc';
            }
            let orden = e.column.sortOrder == 'asc' ? true : false;
            setsortField({columna, sortOrderAsc: orden})
            getData({pageIndex: pageIndex, pageSize: pageSize, searchString: searchField.trim(), orderByField: columna, orderByAscending: orden})
        }   
    }

    return (
        <>
            <div style={{margin: "0.5rem"}}>
                <span style={{display:"flex", justifyContent: "center", fontWeight: 700}}><Typography><span style={{fontWeight: 700}}>{sectionTitle}</span></Typography></span>
                <div style={{ display:"flex", margin: "1rem 0", justifyContent: "space-between", alignItems: "center"}}>
                    <div style={{display: "flex", alignItems: "center", justifyContent: "flex-start"}}>
                        <TextBox
                            label={`${t("Search")}...`}
                            labelMode="floating"
                            value={searchField}
                            mode="text"
                            onValueChange={(value)=>setSearchField(value)}
                            onEnterKey={()=>handleSearch()}
                            valueChangeEvent="keyup"
                            >     
                                <TextBoxButton
                                    name="search"
                                    location="after"
                                    options={{
                                        icon: searchIcon,
                                        stylingMode: 'text',
                                        onClick: ()=>handleSearch()
                                    }}
                                />
                            </TextBox>
                        <div style={{display: "grid", gridTemplateColumns: "1fr auto", columnGap: "0.5rem"}}>
                            {customSearchFields &&
                            <>{customSearchFields}
                            <div>
                                    <Button variant="contained" color="primary" onClick={()=>handleSearch()}>{t("ApplyFilters")}</Button>
                            </div>
                            
                            </>
                            }
                        </div>
                    </div>
                    <div>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{minWidth: "150px"}}
                            startIcon={<img style={{height: "0.9375rem", width: "0.9375rem"}} src={customAddIcon || genericAddIcon}/>}
                            onClick={customCreation? onCreate : handleCreateNew}
                            disabled={!allowCreate}
                        >
                            {t("Add")}
                        </Button>
                    </div>
                </div>
            </div>
            <div style={{margin: "0.5rem"}}>
                    <Table handleCellClick={handleCellClick} reference={tableRef} loading={loading} datasource={dataSource.elements} columnasTabla={[...columnasTabla, ...columnsEdition]} editing={false} onSaving={onSaving} master={master} masterDetail={masterDetail} />
                    <CustomPagination refreshPage={handleRefresh} style={{position: "absolute"}} numElements={numElements} loading={loading} count={dataSource.totalRecords} pageSize={pageSize} pageIndex={pageIndex + 1} totalPages={dataSource.totalPages} handlePageSizeChange={handlePageSizeChange} handlePageIndexChange={handlePageIndexChange} />
            </div>
            <AdminDialog title={dialogTitle} operation={operation} dialogSize={dialogSize || {height: "100%"}} open={openDialog} onClose={closeModal} handleOnClick={handleOnSubmit}>
                {operation === "delete" ? renderDeleteMessage() : <div className="edit-values-wrapper">{renderEditValues()} </div>}
            </AdminDialog>
           <Menu
                anchorEl={menuAnchorEl}
                keepMounted
                key={selectedRowData ? selectedRowData[itemIdField] : "menu"}
                open={selectedRowData != null}
                onClose={()=>{setSelectedRowData(null); setMenuAnchorEl(null)}}
            >   
                <MenuItem onClick={()=>onCustomEditingStart !== null ?  handleStartEditingCustom(selectedRowData) : handleStartEditing(selectedRowData)}> <span style={{display: "flex", alignItems: "center", columnGap: "0.5rem"}}><img height={20} src={editIcon}/> <span>{`${t("Edit")} ${masterTitle}`}</span></span></MenuItem>
                {selectedRowData && allowDelete(selectedRowData.row) && <MenuItem onClick={()=>  onCustomDeletingStart !== null ? handleStartDeletingCustom(selectedRowData) : handleStartDeleting(selectedRowData)}><span style={{display: "flex", alignItems: "center", columnGap: "0.5rem"}}><img height={20} src={deleteIcon}/><span>{`${t("Delete")} ${masterTitle}`}</span></span></MenuItem>}
            </Menu>
        </>
    )
}

export { AdminTable }